export default "__VITE_ASSET__8c8b80a4__"